export default __webpack_public_path__ + "static/media/og2.af58a138.jpeg";